module.exports = __webpack_public_path__ + "assets/img/diy.f59430ee.png";